import React from 'react';

import styles from '../style.scss';


const StatusView = ({ status }) => {
  const statusList = {
    accepted: <div className={styles.statusText}>
      <div className={styles.successImage} />
      Оплачено</div>,
    settled: <div className={styles.statusText}><div className={styles.successImage} />Оплачено</div>,
    refunded: <div className={styles.statusText}><div className={styles.refundImage} />Возврат</div>,
  };
  return (
    <div>{statusList[status]}</div>
  );
};

export default StatusView;
